/** Scoped ritual dialog; reconnects safely when the theme editor reloads a block. */
class OtwsRoutines extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('[data-otws-routines-open]');
    if (!this.dialog || !this.trigger || !this.dialog.showModal) return;
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.trigger.hidden = false;
    this.trigger.addEventListener('click', () => this.dialog.showModal(), options);
    this.querySelector('[data-otws-routines-close]').addEventListener('click', () => this.dialog.close(), options);
    this.dialog.addEventListener('click', (event) => {
      if (event.target !== this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
        this.dialog.close();
      }
    }, options);
    // Close before the theme opens its cart drawer, but never on a failed add.
    this.addEventListener('otws:product-added', () => this.dialog.close(), options);
  }

  disconnectedCallback() {
    this.dialog?.close();
    this.controller?.abort();
  }
}

if (!customElements.get('otws-routines')) customElements.define('otws-routines', OtwsRoutines);
